<div class=" tw-cursor-pointer p-overlay-badge" (click)="showDialog=true">
  @switch (permission) {
  @case('default'){
  <i class="pi pi-bell text-warning !tw-text-xl"></i>
  <p-badge value="&star;" severity="warning"></p-badge>
  }
  @case('denied'){
  <i class="pi pi-bell text-danger !tw-text-xl"></i>
  <p-badge value="&times;" severity="danger"></p-badge>

  }
  @case('granted'){
  <i class="pi pi-bell text-info !tw-text-xl"></i>
  @if(unreadCount>0) {
  <p-badge [value]="unreadCount > 9 ? '9+' : unreadCount" severity="danger"></p-badge>
  }

  }
  }
</div>

<p-dialog [(visible)]="showDialog" position="top" [modal]="true" [dismissableMask]="true" [blockScroll]="true"
  [showHeader]="false" styleClass="tw-m-0 tw-w-screen tw-max-w-sm tw-max-h-[85vh] tw-overflow-y-auto" appendTo="body"
  contentStyleClass="!tw-p-0 !tw-rounded-b-md !tw-rounded-t-none">
  @if(showDialog) {
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-py-4">
    @switch (permission) {
    @case('default'){
    <h1>Notify Me!</h1>
    <p>
      Enable notifications to get the latest updates from us.
    </p>
    <p>
      After clicking the button below, you will be prompted to allow notifications. Click "Allow" to start receiving
      notifications.
    </p>
    <div class="p-fluid tw-p-4">
      <p-button label="Enable Notifications" icon="pi pi-bell" severity="primary"
        (click)="requestPermission()"></p-button>
    </div>
    <div class="p-fluid">
      <p-button label="I will do it later" icon="pi pi-clock" [text]="true" severity="danger"
        (click)="showDialog=false"></p-button>
    </div>
    }
    @case('denied'){
    <h1>Notifications Disabled</h1>
    <p>
      You have disabled notifications from us. To enable notifications, go to your browser settings and allow us to send
      you notifications.
    </p>

    }
    @case('granted'){
    <div class="tw-flex tw-items-center tw-gap-2 text-success">
      <i class="pi pi-check"></i>
      <span>Notifications Enabled!</span>
    </div>
    }
    }

    @if(notifications?.length > 0) {
    <div class="tw-flex tw-justify-between tw-w-full tw-px-2">
      <h5 >Notifications</h5>
      <div class="tw-text-sm tw-cursor-pointer" (click)="markAllAsRead()">
        read all ({{unreadCount}})
      </div>
    </div>
    @for(item of notifications; track $index) {
    <div class="tw-w-full surface-light tw-shadow tw-rownded tw-p-2 tw-cursor-pointer"
      [ngClass]="{'surface-neutral-lighter':item.IsRead, 'surface-light':!item.IsRead}"
      (click)="expand(item)">
      <h6 class="tw-flex tw-justify-between">{{item.Title}} <span class="tw-font-light tw-text-xs">{{item.SentTime |
          timeDiff}}</span></h6>

      <p [ngClass]="{'tw-text-sm tw-line-clamp-1': !item._expanded}">{{item.Body}}</p>

    </div>
    }
    }
  </div>
  }
</p-dialog>